<div>

  <h1>You're almost done!</h1>
  <span>Please review the application to verify information. To change any plan or Advanced Premiuim Tax Credit (ATPC) Information, please return to the previous page.</span>

  <h3 class="header big-space">Plan Information</h3>
  <hr/>
  <div class='plan-information'>
    <span>Product:</span>
    <span class="bold">{{selectedPlan?.attributes?.PRODUCT_NAME}}</span>
    <span>Issuer:</span>
    <span class="bold">{{selectedPlan?.attributes?.RATING_ENTITY}}</span>
    <span>Coverage Start Date:</span>
    <span class="bold">{{effectiveDate}}</span>
    <span>Monthly Premium:</span>
    <span class="bold">{{totalPremiumAmount | currency:'USD'}}</span>
    <span>APTC Selected Amount:</span>
    <span class="bold">{{selectedAPTC | currency:'USD'}}<img src='' alt='{{selectedAPTCToolTipContent}}' [matTooltip]='selectedAPTCToolTipContent'/></span>
    <span>APTC Applied Amount:</span>
    <span class="bold">{{appliedAPTC | currency:'USD'}}<img src='' alt='{{appliedAPTCToolTipContent}}' [matTooltip]='appliedAPTCToolTipContent'/></span>
    <span>Monthly Premium Amount Due:</span>
    <span class="bold">{{individualResponsibilityAmount | currency:'USD'}}</span>
  </div>


  <h3 class="header big-space">Contact Information</h3>
  <hr/>
  <div class='contact-information'>
    <span>Full Name:</span>
    <span class="bold">{{contactInfo.fullName}}</span>
    <span>Address:</span>
    <span class="bold" [innerHTML]="contactInfo.address"></span>
    <span>Primary Phone Number:</span>
    <span class="bold">{{contactInfo.phoneNumber}}</span>
    <span>Email:</span>
    <span class="bold">{{contactInfo.emailAddress}}</span>
  </div>


  <h3 class="header big-space">Primary Information</h3>
  <hr/>
  <div class='primary-information'>
    <span>Primary Applicant Full Name:</span>
    <span class="bold">{{primaryInfo.fullName}}</span>
    <span>Sex:</span>
    <span class="bold">{{primaryInfo.gender}}</span>
    <span>Date of Birth:</span>
    <span class="bold">{{primaryInfo.dateOfBirth}}</span>
    <span>Home Address:</span>
    <span class="bold" [innerHTML]="primaryInfo.address"></span>
    <span>County:</span>
    <span class="bold">{{primaryInfo.county}}</span>
    <span>Have you smoked or used any form of tobacco regularly (4 or more times per week on average excluding religious or ceremonial use) within the last six months?:</span>
    <span class="bold">{{primaryInfo.tobaccoUse}}</span>
    <span>When was the last time you regularly used tobacco?:</span>
    <span class="bold">{{primaryInfo.lastSmokingDate || '-'}}</span>
  </div>


  @if (familyInfo?.length > 0) {
    <h3 class="header big-space" *>Family Information</h3>
    <hr/>
    @for (familyMember of familyInfo; track trackByIndex(i, familyMember); let i = $index) {
      <div class='family-information'>
        <h2>Family Member {{i + 1}}</h2>
        <span>Applicant Full Name:</span>
        <span class="bold">{{familyMember.fullName}}</span>
        <span>Sex:</span>
        <span class="bold">{{familyMember.gender}}</span>
        <span>Date of Birth:</span>
        <span class="bold">{{familyMember.dateOfBirth}}</span>
        <span>Home Address:</span>
        <span class="bold" [innerHTML]="familyMember.address"></span>
        <span>County:</span>
        <span class="bold">{{familyMember.county}}</span>
        <span>Relationship to Primary Applicant:</span>
        <span class="bold">{{familyMember.relationshipToPrimaryApplicant}}</span>
        @if (familyMember.tobaccoUse) {
          <span>Have you smoked or used any form of tobacco regularly (4 or more times per week on average excluding religious or ceremonial use) within the last six months?:</span>
          <span class="bold">{{familyMember.tobaccoUse}}</span>
          <span>When was the last time you regularly used tobacco?:</span>
          <span class="bold">{{familyMember.lastSmokingDate || '-'}}</span>
        }
      </div>
    }
  }

</div>
